<div *ngIf="hasFilter"  class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body p-t-0 p-b-0">
        <div class="row">
          <div class="col-lg-2">
            <div class="form-group">
              <label for="inizio" class="control-label col-form-label">Giorno</label>
              <input id="inizio" required [(ngModel)]="giorno" (ngModelChange)="refresh()" class="form-control" type="date">
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label for="manager" class="control-label col-form-label">Responsabile</label>
              <ng-multiselect-dropdown required [settings]="utentidropdownSettings" [placeholder]="'Seleziona'" name="manager"
                [data]="managers" [(ngModel)]="managerselezionati"  (onFilterChange)="filtroResponsabile($event)" (ngModelChange)="refresh()">
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="card" style="overflow-x: scroll;">
  <div class="card-body" cdkDropListGroup>
    <div class="taskboard page-height p-0">
      <div *ngFor="let item of collection"  class="taskboard-wrapper">
        <div class="taskboard-list">
          <h6 class="taskboard-header font-weight-bold mt-2">{{item.tecnico}}</h6>
          <div class="taskboard-cards">
            <div class="taskboard-task cursor-pointer" *ngFor="let intervento of item.interventi" [ngStyle]="(!intervento.data_fine_prevista && {'background-color': 'rgba(160, 0, 0, 0.2)'}) || (intervento.data_fine_prevista && {'background-color': 'rgba(0, 151, 0, 0.2)'})">
              <div class="taskboard-task-title font-medium">{{ intervento.nome }}</div>
              <small *ngIf="intervento.data_fine_prevista"  class="card-text text-muted">{{intervento.data_fine_prevista | date: 'HH:mm'}}</small>
              <small *ngIf="!intervento.data_fine_prevista"  class="card-text text-muted">{{intervento.data_inizio_prevista | date: 'HH:mm'}}</small>
              <small *ngIf="intervento.data_fine_prevista"  class="card-text text-muted">Pianificato</small>
              <small *ngIf="intervento.sedeObject"  class="card-text text-muted">{{intervento.sedeObject.fullAddress || ''}}</small>
              <small *ngIf="intervento.sedeObject"  class="card-text text-muted">{{intervento.sedeObject.distanza || 0 }} Km</small>
              <div class="mt-2 d-flex justify-content-start align-items-center">
                <a href="javascript:void(0)" class="link" (click)="openModal(intervento)">
                  <i-feather name="eye" class="feather-xs"></i-feather>
                </a>
                <!-- <a href="javascript:void(0)" class="text-danger ml-2" (click)="deleteTask(todo.id)">
                  <i-feather name="trash-2" class="feather-xs"></i-feather>
                </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
